import React, { lazy } from "react";
import { Navigate } from "react-router-dom";
import GuestRoute from "./GuestRoute";

// Guest pages (login, register, etc.)
const Login = lazy(() => import("../pages/auth/Login"));
const Register = lazy(() => import("../pages/auth/Register"));
const SplashScreen = lazy(() => import("../pages/SplashScreen"));
const ResetPassword = lazy(() => import("../pages/auth/ResetPassword"));
const CreateNewPassword = lazy(() => import("../pages/auth/NewPassword"));


const guestRoutes = [
  {
    path: "/splashscreen",
    element: (
      <GuestRoute>
        <SplashScreen />
      </GuestRoute>
    ),
  },
  {
    path: "/login",
    element: (
      <GuestRoute>
        <Login />
      </GuestRoute>
    ),
  },
  {
    path: "/register",
    element: (
      <GuestRoute>
        <Register />
      </GuestRoute>
    ),
  },
  {
    path: "/",
    element: (
      <GuestRoute>
        <Navigate to="/splashscreen" replace />
      </GuestRoute>
    ),
  },
  {
    path: "/reset-password",
    element: (
      <GuestRoute>
        <ResetPassword />
      </GuestRoute>
    ),
  },
  {
    path: "/new-password",
    element: (
      <GuestRoute>
        <CreateNewPassword />
      </GuestRoute>
    ),
  },
];

export default guestRoutes;
